import { EventTypes, track } from '@mc/track-event'
import type { getArticleCategories } from 'libs/server/api/articles'
import { ArticleItem } from 'types/data'

type ArticleCategory = Awaited<ReturnType<typeof getArticleCategories>>[number]

export const trackCategoryCarouselClick = (
  category: Pick<ArticleCategory, 'name'>,
) => {
  track(EventTypes.ARTICLE_PAGE_CLICK, {
    location: 'article-page-body',
    category: 'article-nav-header',
    name: category.name,
  })
}

export const trackFeatureArticleEvent = ({
  action = 'view-article',
  title,
  category,
}: {
  action?: string
  title?: string
  category?: string
}) => {
  track(EventTypes.ARTICLES_HOMEPAGE_CLICK, {
    action,
    location: 'featured',
    title,
    category,
  })
}

export const trackCategoryListItemClicked = (category: ArticleCategory) => {
  track(EventTypes.ARTICLES_HOMEPAGE_CLICK, {
    action: 'view-category',
    location: 'category',
    category: category.name,
  })
}

export const trackArticleClicked = (item: ArticleItem) => {
  track(EventTypes.ARTICLES_HOMEPAGE_CLICK, {
    action: 'view-article',
    location: 'list',
    category: item.title,
  })
}
